import App from "src/features/contact-boxes/components/RentalContactBox";
import exportComponentsToRails from "src/shared/utilities/exportComponentsToRails";

exportComponentsToRails("rentalContactExperience", {
  rentalContactExperience: App
});
